module.exports = __webpack_public_path__ + "static/media/nuvemshop-manual-import1.161e2ca8.png";